const DEFAULT_STATE = {
  settings: null,
  loading: false,
  lowerFee: null,
  upperFee: null,
}

export default {
  ...DEFAULT_STATE,
}
